<template>

    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div v-if="gallery.length == 2" class="col-12 col-lg-4 mb-4 mb-lg-0">
                        <div
                            class="bg-img img-news-gallery-sm d-none d-lg-block"
                            :style="{
                                backgroundImage: `url(${gallery[0].img.url})`,
                            }"
                        ></div>
                        <img :src="gallery[0].img.url" :alt="gallery[0].img.title" class="d-lg-none" />
                        <div
                            v-if="gallery[0].img.imgCredits"
                            v-html="gallery[0].img.imgCredits"
                            class="image-credit pt-3"
                        ></div>
                    </div>

                    <div v-if="gallery.length == 2" class="col-12 col-lg-8">
                        <div
                            class="bg-img img-news-gallery-sm d-none d-lg-block"
                            :style="{
                                backgroundImage: `url(${gallery[1].img.url})`,
                            }"
                        ></div>
                        <img :src="gallery[1].img.url" :alt="gallery[1].img.title" class="d-lg-none" />
                        <div
                            v-if="gallery[1].img.imgCredits"
                            v-html="gallery[1].img.imgCredits"
                            class="image-credit pt-3"
                        ></div>
                    </div>

                    <div v-if="gallery.length == 1">
                        <img v-if="gallery.length == 1" :src="gallery[0].img.url" :alt="gallery[0].img.title" />
                        <div
                            v-if="gallery[0].img.imgCredits"
                            v-html="gallery[0].img.imgCredits"
                            class="image-credit pt-3"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'imagesGallery',
    components: {
        // AssetLoader
    },
    props: {
        gallery: {
            type: Array,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
